<template>
  <!-- 创建OAB预约页面 -->
  <div class="oab-create">
    <!-- 表单信息 -->
    <van-form ref="form" @failed="onFailed" @submit="submitForm" label-width="70">
      <div class="title">
        <div class="title-line"></div>
        <div>基本信息</div>
      </div>
      <van-field
        v-model="formData.name"
        name="name"
        label="车主"
        placeholder="请输入车主信息"
        required
        :rules="[{ required: true, message: '请填写车主信息' }]"
      />
      <van-field
        v-model="formData.telephone"
        label="联系方式"
        placeholder="请输入联系方式"
        required
        maxlength="11"
        name="telephone"
        :rules="[
          { required: true, message: '请输入联系方式' },
          { pattern: mobileValidator, message: '联系方式输入有误' }
        ]"
      />
      <van-field
        v-model="formData.carPlateNumber"
        label="车牌号"
        placeholder="请输入车牌号"
        name="carPlateNumber"
        required
        :rules="[
          { required: true, message: '请输入车牌号' },
          { pattern: plateValidator, message: '车牌号信息输入有误' }
        ]"
      />
      <van-field
        v-model="formData.carModel"
        name="carModel"
        label="车型车系"
        placeholder="请选择车型车系"
        required
        right-icon="arrow"
        @click="showModel += 1"
        :rules="[{ required: true, message: '请选择车型车系' }]"
      />
      <div class="title">
        <div class="title-line"></div>
        <div>预约信息</div>
      </div>
      <van-field
        v-model="formData.dealer"
        name="dealer"
        label="经销商"
        placeholder="请选择经销商"
        required
        :right-icon="dealerFreezeFlag ? '' : 'arrow'"
        @click="selectDealer"
        :rules="[{ required: true, message: '请选择经销商' }]"
      >
        <template #input>
          <div class="fvr dealerBox">
            <p :class="{ placeholder: !dealer.name }">{{ dealer.name || '请选择经销商' }}</p>
            <p @click.stop v-if="dealer && dealer.tel">
              <a :href="`tel:${dealer.tel}`" style="color:#333">
                <span v-if="dealer.openTime">此经销商营业时间为{{ dealer.openTime }}</span> <van-icon class="phone" name="phone" />
              </a>
            </p>
          </div>
        </template>
      </van-field>
      <van-field
        v-model="formData.bookedDate"
        name="bookedDate"
        label="预约时间"
        placeholder="请选择日期"
        required
        right-icon="arrow"
        readonly
        @click="selectBookableDate"
        :rules="[{ required: true, message: '请选择日期' }]"
      />
      <van-field
        class="label-hidden"
        v-model="formData.bookTime"
        name="bookTime"
        label="预约时间"
        placeholder="请选择时间"
        right-icon="arrow"
        readonly
        @click="selectBookableTime"
        :rules="[{ required: true, message: '请选择时间' }]"
      />
      <p class="fvr bookTimeExplain themeColor" @click="isShowBookTimeExplain = true">到店时间说明 <van-icon name="info-o" color="#3088c5" /></p>
      <van-field v-model="formData.note" name="note" label="备注信息" placeholder="请输入内容" />
      <van-field name="serviceType" label="服务类型" placeholder="请选择服务类型">
        <!-- required
        :rules="[{ validator: serviceTypeValidator, message: '请选择服务类型' }]" -->
        <template #input>
          <van-checkbox-group label="12321" v-model="formData.serviceType" direction="horizontal">
            <van-row class="fvlrw">
              <van-col span="12" v-for="item in serviceTypeArr" :key="item.id">
                <van-checkbox checked-color="#3088c5" :name="item.id" shape="square">{{ item.text }}</van-checkbox>
              </van-col>
            </van-row>
          </van-checkbox-group>
        </template>
      </van-field>
      <div class="button-group">
        <van-button size="small" @click="cancelSub">取消</van-button>
        <van-button size="small" type="primary" color="#3088c5" native-type="submit">立即预约</van-button>
      </div>
    </van-form>
    <!-- 选择时间弹窗 -->
    <TimePop :showPopUp="showTimeNum" :currentDate="formData.bookTime" :bookTimeArr="bookTimeArr" @confirm="timeConfirm"></TimePop>
    <!-- 选择车系 -->
    <SelectCar :datas="modelData" :showPopUp="showModel" :currentCar="currentCar" @selectCarResult="selectCarResult" from="oab" />
    <!-- 选择经销商 -->
    <SwitchDealer :showNum="showNum" @dealerFn="dealerFn" from="oab" />
    <!-- 选择日期 -->
    <section v-if="showDateNum">
      <van-calendar
        v-model:show="showDateNum"
        :formatter="calendarFormatter"
        color="#3088c5"
        :default-date="defaultDate"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
      />
    </section>

    <!-- 确定弹窗 -->
    <van-dialog
      v-model:show="isShowDialog"
      title=""
      :before-close="beforeCloseDialog"
      show-cancel-button
      :confirm-button-text="dialogConfig.confirmButtonText"
      confirm-button-color="#3088c5"
    >
      <div class="dialogContent">
        <h3 class="title" v-if="dialogConfig.title">
          {{ dialogConfig.title }}
        </h3>
        <div v-html="dialogConfig.content"></div>
      </div>
    </van-dialog>
    <load :isShow="loading" />
    <!-- 到店时间说明弹窗 -->
    <van-dialog v-model:show="isShowBookTimeExplain" title="到店时间说明" confirm-button-color="#3088c5">
      <div class="dialogContent">
        您的预约到店时间最终将由经销商服务顾问与您沟通，谢谢您的理解和支持！
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { reactive, toRefs, watch, nextTick, onMounted, onUnmounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import load from '@/components/oab/fullLoad.vue'
import SelectCar from '@/components/common/SelectCar'
import TimePop from '@/components/common/TimePop.vue'
import SwitchDealer from '@/components/dealer/SwitchDealer'
import { mobileValidator, plateValidator } from '@/util/regEx.js'
import { showToast } from '@/util/couponCollection'
import { getCustomerInfo } from '@/api/mine'
import { getDealerOpenTime, getBookableDates, getTimeslotSeats, getModelData, createReservation, createReservationSecond } from '@/api/oab'
import { serviceTypeArr } from '@/util/oab'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: {
    load,
    SelectCar,
    SwitchDealer,
    TimePop
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    let { from, orderId = '' } = route.query
    const dealerFreezeFlag = ['myPlanList'].includes(from)
    const note = from === 'home' ? '维修保养' : ['myPlanList', 'orderList', 'orderDetail'].includes(from) ? '致友计划服务预约' : ''
    const serviceTypeData = serviceTypeArr.filter(item => ['01', '10', '08', '90'].includes(item.id))
    const state = reactive({
      from,
      orderId,
      dealerFreezeFlag,
      formData: {
        name: '',
        telephone: '',
        carPlateNumber: '',
        carModel: '',
        dealer: '',
        bookedDate: '',
        bookTime: '',
        note,
        serviceType: []
      },
      modelData: [''],
      currentCar: '',
      showModel: 0,
      showNum: 0,
      showDateNum: false,
      showTimeNum: 0,
      dealer: {},
      minDate: new Date(),
      maxDate: new Date(),
      defaultDate: new Date(),
      bookedDateArr: [], //日期字符串数组['2021-06-17', '2021-06-21']
      bookTimeDataArr: [], //时间数据[ { startTime: '0800', endTime: '0830' }, { startTime: '0830', endTime: '0900' }]
      bookTimeArr: [], //只含startTime的时间数据[ '0800', '0830','0900']
      slotseatId: '',
      serviceTypeArr: serviceTypeData,
      dialogConfig: {
        // title: '确认取消',
        content: '该车当天已有预约</br>请确认是否继续预约？',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      },
      isShowDialog: false,
      loading: false,
      isShowBookTimeExplain: false
    })

    // 去选择日期
    const selectBookableDate = async () => {
      let dealerGssn = state.dealer?.gssn || ''
      if (!dealerGssn) {
        showToast('请先选择一个经销商')
        return false
      }
      try {
        await getBookableDatesFn()
        nextTick(() => {
          if (!state.bookedDateArr.length) {
            showToast('当前经销商无可预约日期')
            return false
          }
          state.showDateNum = true
        })
      } catch (e) {
        console.error(e)
      }
    }

    // 确认日期
    const onConfirm = value => {
      console.log('onConfirm--calendar->', value)
      state.formData.bookedDate = moment(value).format('YYYY-MM-DD')
      state.showDateNum = false
    }
    // 获取可预约日期
    const getBookableDatesFn = async () => {
      let dealerGssn = state.dealer?.gssn || ''
      if (!dealerGssn) {
        showToast('请先选择一个经销商')
        return false
      }
      // console.log('getBookableDatesFn->获取可预约日期')
      try {
        let bookedDate = await getBookableDates({ dealerGssn })
        // bookedDate = ['2021-07-03', '2021-06-21', '2021-06-28', '2021-07-11', '2021-07-14']
        // bookedDate = []
        if (bookedDate.length) {
          state.minDate = new Date(bookedDate[0].replace(/-/g, '/'))
          state.maxDate = new Date(bookedDate[bookedDate.length - 1].replace(/-/g, '/'))
          state.bookedDateArr = bookedDate
          // 有已选的日期且在新的范围类，设置默认日期
          if (state.formData.bookedDate && bookedDate.includes(state.formData.bookedDate)) {
            state.defaultDate = new Date(state.formData.bookedDate.replace(/-/g, '/'))
          } else {
            // 未选日期，默认选中第一天
            state.formData.bookedDate = bookedDate[0]
            state.defaultDate = new Date(bookedDate[0].replace(/-/g, '/'))
          }
        } else {
          state.defaultDate = new Date()
          state.minDate = new Date()
          state.maxDate = new Date()
          state.bookedDateArr = []
          state.formData.bookedDate = ''
          showToast('当前经销商无可预约日期')
        }
      } catch (e) {
        state.defaultDate = new Date()
        state.minDate = new Date()
        state.maxDate = new Date()
        state.bookedDateArr = []
        state.formData.bookedDate = ''
        showToast(e.message, '获取预约日期失败')
        throw e
      }
    }
    // 日历格式化
    const calendarFormatter = day => {
      let item = moment(day.date).format('YYYY-MM-DD')
      let isAllow = state.bookedDateArr.includes(item)
      // 不在范围的日期不可选
      !isAllow && (day.type = 'disabled')
      return day
    }
    // 去选择时间
    const selectBookableTime = async () => {
      let res = await getTimeslotSeatsFn()
      res && state.showTimeNum++
    }
    // 确认时间
    const timeConfirm = value => {
      state.formData.bookTime = value
    }
    watch(
      () => state.formData.bookTime,
      value => {
        if (value) {
          let bookStartTime = value.split(':').join('')
          let bookTimeObj = state.bookTimeDataArr.find(item => item.startTime === bookStartTime)
          state.slotseatId = bookTimeObj?.slotseatId
        } else {
          state.slotseatId = ''
        }
      }
    )
    watch(
      () => state.formData.bookedDate,
      value => {
        if (value) {
          // 需要获取检查新的座席号
          getTimeslotSeatsFn()
        }
      }
    )
    // 获取座席号
    const getTimeslotSeatsFn = async () => {
      let dealerGssn = state.dealer?.gssn || ''
      if (!dealerGssn) {
        showToast('请先选择一个经销商')
        return false
      }
      let date = state.formData.bookedDate
      if (!date) {
        showToast('请先选择预约日期')
        return false
      }
      // console.log('getTimeslotSeatsFn->获取座席号')
      try {
        let timeslotSeats = await getTimeslotSeats({ dealerGssn, date })
        // timeslotSeats = [
        //   { startTime: '0800', endTime: '0830' },
        //   { startTime: '0830', endTime: '0900' },
        //   { startTime: '1030', endTime: '1100' }
        // ]
        let bookTimeArr = timeslotSeats.map(item => item.startTime)
        let slotseatIdArr = timeslotSeats.map(item => item.slotseatId)
        state.bookTimeArr = bookTimeArr
        state.bookTimeDataArr = timeslotSeats
        // 已选的时间不在新的范围类，重置
        if (state.formData.bookTime) {
          let bookStartTime = state.formData.bookTime.split(':').join('')
          if (!bookTimeArr.includes(bookStartTime)) {
            state.formData.bookTime = ''
            state.slotseatId = ''
          }
        }
        if (!slotseatIdArr.includes(state.slotseatId)) {
          state.formData.bookTime = ''
          state.slotseatId = ''
        }
        if (bookTimeArr.length === 0) {
          showToast('可预约时间为空')
          state.formData.bookTime = ''
          state.slotseatId = ''
        }
        return bookTimeArr.length
      } catch (e) {
        state.bookTimeArr = []
        state.bookTimeDataArr = []
        state.formData.bookTime = ''
        state.slotseatId = ''
        showToast(e.message, '获取座席号失败')
      }
    }
    watch(
      () => state.dealer,
      (value, old) => {
        if (old.gssn !== value.gssn) {
          state.formData.bookTime = ''
          state.slotseatId = ''
        }
        if (value && value.gssn) {
          getBookableDatesFn()
        } else {
          state.formData.bookedDate = ''
        }
      }
    )
    // 校验失败
    const onFailed = data => {
      console.error('onFailed-->', data)
    }
    // 确认车型
    const selectCarResult = data => {
      console.log('selectCarResult-确认车型->', data)
      if (data && data.iArr && data.iArr.length) {
        let [seriesIndex, modelIndex] = data.iArr
        let modelList = state.modelData[seriesIndex]['children']
        state.currentCar = { ...data, seriesIndex, modelList, modelIndex }
        state.formData.carModel = data.text
      }
    }
    // 去选择经销商
    const selectDealer = () => {
      if (state.dealerFreezeFlag) return
      state.showNum += 1
    }
    // 选中一个经销商
    const dealerFn = data => {
      // console.log('选中一个经销商->', data)
      state.formData.dealer = data.name
      setOpenTime(data)
    }
    // 设置经销商营业时间
    const setOpenTime = async data => {
      let { dealerId } = data
      try {
        let { openTime } = await getDealerOpenTime({ dealerId })
        data.openTime = openTime || '09:00-18:00'
      } catch (e) {
        showToast(e.message, '获取经销商营业时间失败')
      } finally {
        state.dealer = data
      }
    }
    // 取消预约
    const cancelSub = () => {
      router.go(-1)
    }
    // 计算标签
    const getTag = data => {
      let endTime = new Date(`${data.bookedDate.replace(/-/g, '/')} ${data.bookTime}`).getTime()
      let date = moment(endTime).diff(moment(new Date().getTime()), 'hours')
      return date >= 8 ? 0 : 1
    }
    // 提交表单
    const submitForm = _.debounce(async data => {
      // console.log('submitForm-->', data)
      // bookTime: "08:00"
      // bookedDate: "2021-06-17"
      // carModel: "Mercedes-AMG CLA 35 4MATIC Coupe"
      // carPlateNumber: "京A12345"
      // dealer: "wwdcsbv"
      // name: "梵蒂冈"
      // note: "维修保养"
      // serviceType: Proxy {0: "c"}
      // telephone: "13882351111"

      try {
        let param = _.clone(data)
        Reflect.deleteProperty(param, 'dealer')
        Reflect.deleteProperty(param, 'bookTime')
        param.tag = getTag(data)
        param.dealerGssn = state.dealer.gssn
        param.serviceType = data.serviceType.join(',')
        param.carModel = `${state.currentCar?.series || ''} ${data.carModel}`.trim()
        param.slotseatId = state.slotseatId
        param.orderId = state.orderId
        param.bookedTime = data.bookTime
        // console.log('createReservation', param)
        state.loading = true
        let res = await createReservation(param)
        state.loading = false
        if (res.status) {
          // res为true--》该车当天已有预约,弹窗确认
          state.dialogConfig = Object.assign(state.dialogConfig, { subParam: { param: { ...param, isSecond: true } }, cb: createReservationSecond })
          state.isShowDialog = true
        } else {
          toDetail(res.reservationId)
        }
      } catch (e) {
        state.loading = false
        showToast(e.message, '创建预约失败')
      }
    }, 300)
    //关闭弹窗
    const beforeCloseDialog = async action => {
      if (action === 'confirm') {
        try {
          const {
            subParam: { param },
            cb
          } = state.dialogConfig
          let res = cb && (await cb(param))
          nextTick(async () => {
            await toDetail(res.reservationId)
          })
          return true
        } catch (e) {
          showToast(e.message, '操作失败')
        }
      }
      if (action === 'cancel') {
        state.dialogConfig.subParam = {}
        return true
      }
    }
    // 返回上一页
    const toDetail = id => {
      showToast('您的预约创建成功', {
        type: 'html',
        duration: 2000,
        onClose: () => {
          router.replace({ path: '/oabDetail', query: { from: 'oabCreate', oabId: id } })
        }
      })
    }
    // 服务类型校验函数
    const serviceTypeValidator = data => {
      // console.log('serviceTypeValidator-->', data)
      return data && data.length ? !!(data && data.length) : false
    }
    // 获取车型车系
    const getModelDataFn = async () => {
      try {
        let modelData = await getModelData()
        state.modelData = modelData && modelData.length ? modelData : ['']
        // 设置第一个为默认值
        // let [seriesIndex, modelIndex] = [0, 0]
        // let modelList = modelData[seriesIndex]?.children || []
        // state.currentCar = { ...modelData[seriesIndex], seriesIndex, modelList, modelIndex }
        // state.formData.carModel = modelData[seriesIndex]?.text || ''
      } catch (e) {
        state.modelData = ['']
        state.currentCar = {}
        showToast(e.message, '获取车型车系数据失败')
      }
    }
    // 获取个人信息
    const getCustomerInfoFn = async () => {
      try {
        let customerInfo = await getCustomerInfo()
        state.formData.name = customerInfo?.username || ''
        state.formData.telephone = customerInfo?.phone || ''
        !state.formData.carPlateNumber && (state.formData.carPlateNumber = customerInfo?.licensePlate || '')
        !state.formData.carModel && (state.formData.carModel = customerInfo?.model || '')
      } catch (e) {
        showToast(e.message, '获取个人信息数据失败')
      }
    }
    const reseState = () => {
      let oabInfo = store.state?.oabInfo || {}
      let dealerInfo = oabInfo?.dealerInfo || {}
      let openTime = dealerInfo.openTime || (dealerInfo.startTime && dealerInfo.endTime ? `${dealerInfo.startTime}-${dealerInfo.endTime}` : '')
      state.dealer = { ...dealerInfo, gssn: dealerInfo.gssnCode, openTime }
      state.formData.dealer = state.dealer?.name || ''
      state.formData.carPlateNumber = oabInfo?.carInfo?.plate || ''
      state.formData.carModel = oabInfo?.carInfo?.model || ''
    }
    onMounted(async () => {
      reseState()
      nextTick(async () => {
        await getCustomerInfoFn()
        await getModelDataFn()
      })
    })
    onUnmounted(() => {
      store.dispatch('setOabInfo', null)
    })
    const carId = computed(() => state.currentCar?.carId || '')
    watch(
      () => carId.value,
      (n, o) => {
        console.log('watch--carId.value-->', n)
        store.commit('SETCARID', n)
        if (n !== o && n) {
          state.formData.dealer = ''
          state.dealer = {}
        }
      }
    )
    return {
      ...toRefs(state),
      carId,
      onConfirm,
      timeConfirm,
      selectBookableDate,
      selectBookableTime,
      selectCarResult,
      dealerFn,
      mobileValidator,
      plateValidator,
      onFailed,
      cancelSub,
      submitForm,
      selectDealer,
      calendarFormatter,
      serviceTypeValidator,
      beforeCloseDialog
    }
  }
}
</script>
<style lang="scss" scoped>
.oab-create {
  background: #fff;
  .title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    padding: 20px 0px 20px 20px;
    display: flex;
    height: 16px;
    line-height: 16px;
    .title-line {
      width: 2px;
      height: 16px;
      margin: 2px 10px 26px 0;
      border-radius: 100px;
      background-color: #3088c5;
    }
  }
  .selector-self {
    width: 100%;
    padding: 0;
    height: auto;
    border: none;
  }
  .button-group {
    padding-bottom: calc(10px + constant(safe-area-inset-bottom));
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    button {
      width: 160px;
    }
  }
  .label-hidden {
    :deep(.van-field__label) {
      visibility: hidden;
    }
  }
  :deep(.van-field--error .van-field__control::placeholder) {
    color: #c8c9cc !important;
  }
  :deep(.van-field--error .van-field__control) {
    color: #323233 !important;
  }
  :deep(.dealerBox) {
    display: block;
    width: 100%;
    .van-cell {
      padding: 0;
    }
  }
}
.phone {
  margin: 0 0 0 20px;
  font-size: 20px;
  color: #3088c5;
  transform: rotate(-90deg);
}
.placeholder {
  color: #c8c9cc;
}
:deep(.van-checkbox__icon) {
  font-size: 14px;
}
.van-checkbox--horizontal {
  // margin-right: 0;
  margin-bottom: 6px;
}
:deep(.van-popup.van-dialog button) {
  background: #fff;
  color: #666;
}
:deep(.dialogContent) {
  padding: 38px 10px;
  color: #333;
  font-size: 16px;
  font-weight: 400;
}
.bookTimeExplain {
  margin: 2px 20px 0px;
}
</style>
